import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, AfterViewInit {
	user: any = { username: '', password: '' };
	year: number = new Date().getFullYear();
	loadershow: boolean = false;
	loginErrorshow: boolean = false;
	loginFormErr: string = "";
	adminAccess: any;
	data: any = null;
	is_mfa = false;
	auth: any = { otp: null };

	constructor(private apiService: ApiService, private router: Router, private renderer: Renderer2, private toastr: ToastrService, private route: ActivatedRoute,) { }

	ngAfterViewInit(): void { }

	ngOnInit(): void {
		if (localStorage.getItem('attendance_token') != null && localStorage.getItem('attendance_token') != undefined) {
			this.gotoDashboard();
		}
	}

	mfasession: any;
	submitForm(user: any) {
		this.loadershow = true;
		this.apiService.loginAPI(user).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				if (data.mfasession) {
					this.mfasession = data.mfasession;
					this.is_mfa = true;
				} else {
					this.data = data;
					this.proceedLogin();
				}
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Username or Password is incorrect.";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	verifyOTP() {
		if (!this.auth.otp) {
			this.toastr.warning("Please enter OTP", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.loadershow = true;
		let data: any = {
			username: this.user.username,
			session: this.mfasession,
			user_code: this.auth.otp
		};
		this.apiService.loginByMFA(data).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				this.data = data;
				this.proceedLogin();
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Invalid Code";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	proceedLogin() {
		this.toastr.success("Logged in", 'Success', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
		localStorage.setItem('attendance_token', "Bearer " + this.data["token"]);
		this.gotoDashboard();
	}

	getLastParamValue(initialUrl: string, param: string): string | null {
		let current = initialUrl;
		let lastValue: string | null = null;
		while (true) {
			const dummy = new URL(current, 'http://dummy');
			const value = dummy.searchParams.get(param);
			if (!value) break;
			lastValue = value;
			current = decodeURIComponent(value);
		}
		return lastValue;
	}

	gotoDashboard() {
		/* let returnUrl = this.getLastParamValue(this.router.url, 'returnUrl') || this.apiService.getHomeURL();
		this.router.navigate([returnUrl]); */
		this.router.navigate([this.apiService.getHomeURL()]);
	}
}
